import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {VMessage} from "../v-message.model";

export class VMessageDgSearchResults extends GenericDgSearchResults {
  public results: VMessage[];

  constructor(total: number, results: VMessage[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
